var map = {
	"./autorretrato/autorretrato-cover.png": "./src/assets/portfolio-img/autorretrato/autorretrato-cover.png",
	"./blaster/blaster-cover.png": "./src/assets/portfolio-img/blaster/blaster-cover.png",
	"./dot2020/dot2020-cover.png": "./src/assets/portfolio-img/dot2020/dot2020-cover.png",
	"./dot2021/dot2021-cover.png": "./src/assets/portfolio-img/dot2021/dot2021-cover.png",
	"./eie3/eie3-cover.png": "./src/assets/portfolio-img/eie3/eie3-cover.png",
	"./grimes/grimes-cover.png": "./src/assets/portfolio-img/grimes/grimes-cover.png",
	"./lovecraft/lovecraft-cover.png": "./src/assets/portfolio-img/lovecraft/lovecraft-cover.png",
	"./malamente/malamente-cover.png": "./src/assets/portfolio-img/malamente/malamente-cover.png",
	"./popuphm/popuphm-cover.png": "./src/assets/portfolio-img/popuphm/popuphm-cover.png",
	"./uiux/uiux-cover.png": "./src/assets/portfolio-img/uiux/uiux-cover.png",
	"./westworld/westworld-cover.png": "./src/assets/portfolio-img/westworld/westworld-cover.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/portfolio-img sync recursive ^\\.\\/.*\\/.*\\-cover\\.png$";